<template>
  <ValidationObserver
    ref="formValidation"
    v-slot="{ pristine, handleSubmit, invalid }"
    slim
  >
    <form
      role="form"
      class="invites form-horizontal"
      @submit.prevent="handleSubmit(onSaveAll)"
    >
      <fieldset>
        <Field
          :label="$t('USER_EMAIL_ADDRESS')"
          :has-tooltip="true"
          :tooltip-text="$t('USER_EMAIL_ADDRESS_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ valid, dirty }"
              slim
              rules="required|email"
              vid="confirmEmail"
            >
              <div class="col-sm-5 col-md-4">
                <input
                  id="emailInput"
                  v-model="email"
                  :placeholder="$t('USER_EMAIL_ADDRESS_DEFAULT')"
                  type="email"
                  autocomplete="off"
                  class="form-control"
                  required="true"
                >
                <Typeahead
                  v-if="existingUsers.length"
                  v-model="email"
                  target="#emailInput"
                  :data="existingUsers"
                  item-key="email"
                  @input="onEmailChange"
                />
                <span
                  v-if="dirty && !valid"
                  v-t="'USER_INVALID_EMAIL'"
                  class="text-danger" 
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('USER_EMAIL_CONFIRM')"
          :has-tooltip="true"
          :tooltip-text="$t('USER_EMAIL_CONFIRM_TT')"
        >
          <template #element>
            <ValidationProvider 
              v-slot="{ valid, dirty }"
              slim
              rules="required|email|confirmed:confirmEmail"
            >
              <div class="col-sm-5 col-md-4">
                <input
                  data-testid="confirm-email"
                  v-model="confirmEmail"
                  :placeholder="$t('USER_EMAIL_ADDRESS_DEFAULT')"
                  type="email"
                  autocomplete="off"
                  class="form-control"
                  required="true"
                >
                <span
                  v-if="dirty && !valid"
                  v-t="'USER_INVALID_CONFIRM_EMAIL'"
                  class="text-danger"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('FIRST_NAME')"
          :has-tooltip="true"
          :tooltip-text="$t('FIRST_NAME_TT')"
        >
          <template #element>
            <ValidationProvider 
              slim
              rules="required"
            >
              <div class="col-sm-5 col-md-4">
                <input
                  data-testid="first-name"
                  v-model="firstName"
                  type="text"
                  class="form-control"
                  required="true"
                  :placeholder="$t('USER_FIRST_NAME_DEFAULT')"
                >
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('LAST_NAME')"
          :has-tooltip="true"
          :tooltip-text="$t('LAST_NAME_TT')"
        >
          <template #element>
            <ValidationProvider
              slim
              rules="required"
            >
              <div class="col-sm-5 col-md-4">
                <input
                  data-testid="last-name"
                  v-model="lastName"
                  type="text"
                  class="form-control"
                  required="true"
                  :placeholder="$t('USER_LAST_NAME_DEFAULT')"
                >
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <div class="form-group">
          <div class="col-sm-offset-3 col-md-offset-3 col-md-8 col-sm-8">
            <PrimaryButton
              :disabled="pristine || invalid"
              :show-loader-on-form="showLoader"
              size="sm"
              @click="submit"
              data-testid="submit"
            >
              {{ $t('INVITE_USER_SUBMIT_BUTTON') }}
            </PrimaryButton>

            <button
              v-t="'CANCEL'"
              class="btn btn-sm btn-danger m-l-15"
              @click="$emit('cancel')"
            />
          </div>
        </div>
      </fieldset>
    </form>
  </ValidationObserver>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';

import Field from '@/core/components/LabelAndElement/LabelAndElement';
import PrimaryButton from '@/core/components/PrimaryButton';

export default {
  name: 'InviteForm',
  components: { Field, PrimaryButton },
  props:{
    existingUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      email: null,
      confirmEmail: null,
      firstName: null,
      lastName: null,
      showLoader: false
    };
  },
  methods:{
    onEmailChange(user) {
      if(user?.email) {
        this.email = user.email;
        this.confirmEmail = user.email;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
      }
    },
    submit() {
      this.showLoader = true;
      this.$emit('submit', {
        email: this.email,
        confirmEmail: this.confirmEmail,
        firstName: this.firstName,
        lastName: this.lastName,
      });
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
};
</script>

<style lang="scss" scoped>
</style>